const OAUTH_AUTHORIZE_PATH = "/o/authorize/";
const OAUTH_AUTHORIZE_NEXT_SESSION_KEY = "oauthAuthorizeNext";

function normalizeOAuthAuthorizeNext(value: string | null): string | null {
  if (!value) return null;

  try {
    const target = new URL(value, window.location.origin);
    if (target.origin !== window.location.origin || target.pathname !== OAUTH_AUTHORIZE_PATH) {
      return null;
    }
    return `${target.pathname}${target.search}${target.hash}`;
  } catch (_error) {
    return null;
  }
}

export function getOAuthAuthorizeNext(): string | null {
  return normalizeOAuthAuthorizeNext(new URLSearchParams(window.location.search).get("next"));
}

export function rememberOAuthAuthorizeNext(): void {
  const next = getOAuthAuthorizeNext();
  if (next) {
    window.sessionStorage.setItem(OAUTH_AUTHORIZE_NEXT_SESSION_KEY, next);
  }
}

export function takeRememberedOAuthAuthorizeNext(): string | null {
  const next = normalizeOAuthAuthorizeNext(
    window.sessionStorage.getItem(OAUTH_AUTHORIZE_NEXT_SESSION_KEY)
  );
  window.sessionStorage.removeItem(OAUTH_AUTHORIZE_NEXT_SESSION_KEY);
  return next;
}
